import React from 'react';
import BubbleMessage from './BubbleMessage';
import { useTranslate } from '@tolgee/react';

const NonsupportMessage: React.FC<{}> = (props) => {
  const { t } = useTranslate();

  return <BubbleMessage className="left">[{t('notification.UNKNOWN_MESSAGE_TYPE')}]</BubbleMessage>;
};
export default NonsupportMessage;
